import React, { useState } from 'react';
import PropTypes from 'prop-types';
import HeaderBrand from '../../Molecules/HeaderBrand/HeaderBrand';
import HeaderActions from '../HeaderActions/HeaderActions';
import MobileMenu from '../MobileMenu/MobileMenu';
import Navbar from '../Navbar/Navbar';

const Header = ({
    primaryPages = [],
    locales = [],
    currentLocale = null,   // ✅ add this
}) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <>
            <header className="modern-header">
                <div className="header-content">
                    <HeaderBrand />

                    <div className="header-desktop-nav">
                        <Navbar primaryPages={primaryPages} />
                    </div>

                    <HeaderActions
                        onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        isMenuOpen={isMobileMenuOpen}
                        locales={locales}
                        currentLocale={currentLocale}  // ✅ use prop
                    />
                </div>
            </header>

            <MobileMenu
                primaryPages={primaryPages}
                isOpen={isMobileMenuOpen}
                onClose={() => setIsMobileMenuOpen(false)}
            />
        </>
    );
};

Header.propTypes = {
    primaryPages: PropTypes.array,
    locales: PropTypes.array,
    currentLocale: PropTypes.object,   // ✅ add this
};

export default Header;